var EEcommerceSystemName = /*#__PURE__*/ function(EEcommerceSystemName) {
    EEcommerceSystemName["Paddle"] = "Paddle";
    return EEcommerceSystemName;
}(EEcommerceSystemName || {});
var EEcommerceSystemEnvironment = /*#__PURE__*/ function(EEcommerceSystemEnvironment) {
    EEcommerceSystemEnvironment["Production"] = "production";
    EEcommerceSystemEnvironment["Sandbox"] = "sandbox";
    return EEcommerceSystemEnvironment;
}(EEcommerceSystemEnvironment || {});
export { EEcommerceSystemName, EEcommerceSystemEnvironment };
